import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import { Tabs } from "components";
import { createFormHelper } from "lib/Form";
import { StatusesList } from "modules/StatusListDashboard/components";
import { useStatusesListQuery, useUpdateStatusesMutation } from "modules/StatusListDashboard/hooks";
import "modules/StatusListDashboard/StatusListDashboard.scss";

import type { TabData } from "components";
import type { StatusListFormValues } from "modules/StatusListDashboard/components";

const FormHelper = createFormHelper<StatusListFormValues>();

export const StatusListDashboard = () => {
  const { t } = useTranslation();

  const { data: statuses = [], isLoading } = useStatusesListQuery();
  const { mutate: updateStatuses, isPending } = useUpdateStatusesMutation();

  const tabs: Map<string, TabData> = useMemo(
    () => new Map([["statuses", { data: [], id: "statuses", title: t("v8_statuses", "Statuses"), icon: <Icon className="thumbtack" /> }]]),
    []
  );

  const handleSubmit = (values: StatusListFormValues) => updateStatuses(values);

  return (
    <FormHelper.Form onSubmit={handleSubmit} defaultValues={{ statuses }}>
      <div className="StatusListDashboard">
        <div className="StatusListDashboard-header">
          <div className="row center">
            <div className="full tabs">
              <Tabs data={tabs} />
            </div>
            <div className="save">
              <Button color="green" type="submit" loading={isPending} disabled={isPending || isLoading}>
                {t("v8_save", "Save")}
                <Icon className="check" />
              </Button>
            </div>
          </div>
        </div>

        <StatusesList />
      </div>
    </FormHelper.Form>
  );
};
